import React from 'react';
import { TierConfigType } from '@gamiphy/bl/level';
import { useTranslation } from '@gamiphy/react-i18n';

export const usePointsLabel = (type: TierConfigType): string => {
  const { t } = useTranslation();

  return React.useMemo((): string => {
    switch (type) {
      case TierConfigType.gainedPoints:
        return t('levels.points', 'Points');
      case TierConfigType.valueOfPurchases:
        return t('levels.purchase.amount', 'Total purchases amount');
      case TierConfigType.numberOfPurchases:
        return t('levels.total.purchases', 'Count of Total Purchases');
      default:
        return t('level.points.exp', 'EXP Points');
    }
  }, [type]);
};
